export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_09.e775aa40.png";